import api from './ApiService';

export async function getTimeline(id = '') {
  const { data } = await api.get(`timeline/${id}`);
  return data;
}
